import React from 'react';

interface PieceCardProps {
  piece: any;
  onEdit: (piece: any) => void;
  onDelete: (piece: any) => void;
  isSelected?: boolean;
  onToggleSelection?: () => void;
  canEdit?: boolean;
  canDelete?: boolean;
  canBulk?: boolean;
}

const PieceCard: React.FC<PieceCardProps> = ({ 
  piece, 
  onEdit, 
  onDelete, 
  isSelected = false, 
  onToggleSelection,
  canEdit = false,
  canDelete = false,
  canBulk = false
}) => {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-3 hover:shadow-md transition-shadow">
      {/* En-tête avec case à cocher, nom et actions */}
      <div className="flex items-start gap-2 mb-2">
        {/* Case à cocher à gauche */}
        {onToggleSelection && canBulk && (
          <label className="flex-shrink-0 cursor-pointer mt-0.5">
            <input
              type="checkbox"
              checked={isSelected}
              onChange={onToggleSelection}
              className="form-checkbox h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-2 focus:ring-blue-500"
              onClick={(e) => e.stopPropagation()}
            />
          </label>
        )}
        
        {/* Contenu principal */}
        <div className="flex items-start justify-between gap-2 flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-1 min-w-0">
            <h3 className="font-semibold text-gray-900 text-sm truncate">{piece.nom}</h3>
            {piece.numero && (
              <span className="px-2 py-0.5 text-xs font-medium rounded bg-purple-100 text-purple-800 flex-shrink-0">
                #{piece.numero}
              </span>
            )}
          </div>
          {(canEdit || canDelete) && (
            <div className="flex gap-1 flex-shrink-0">
              {canEdit && (
                <button
                  onClick={() => onEdit(piece)}
                  className="text-blue-600 hover:text-blue-800 p-1 rounded hover:bg-blue-50"
                  title="Modifier"
                >
                  ✏️
                </button>
              )}
              {canDelete && (
                <button
                  onClick={() => onDelete(piece)}
                  className="text-red-600 hover:text-red-800 p-1 rounded hover:bg-red-50"
                  title="Supprimer"
                >
                  🗑️
                </button>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Localisation - Site et Bâtiment */}
      <div className="space-y-0.5 mb-2">
        {piece.batiment?.site && (
          <div className="flex items-center gap-1.5 text-xs text-gray-600">
            <span className="flex-shrink-0">📍</span>
            <span className="truncate">{piece.batiment.site.nom}</span>
          </div>
        )}
        {piece.batiment && (
          <div className="flex items-center gap-1.5 text-xs text-gray-600">
            <span className="flex-shrink-0">🏗️</span>
            <span className="truncate">{piece.batiment.nom}</span>
          </div>
        )}
        {piece.etage && (
          <div className="flex items-center gap-1.5 text-xs text-gray-600">
            <span className="flex-shrink-0">🏢</span>
            <span>Étage {piece.etage}</span>
          </div>
        )}
      </div>

      {/* Statistiques */}
      <div className="flex items-center gap-3 text-xs text-gray-500">
        <span className="flex items-center gap-1">
          <span>📦</span>
          <span>{piece.zones?.length || 0} zones</span>
        </span>
        <span className="flex items-center gap-1">
          <span>📋</span>
          <span>{piece.boxes?.length || 0} boxes</span>
        </span>
        <span className="flex items-center gap-1">
          <span>🎯</span>
          <span>{piece.zones?.reduce((total: number, zone: any) => total + (zone.objets?.length || 0), 0) + 
                 piece.boxes?.reduce((total: number, box: any) => total + (box.objets?.length || 0), 0) || 0} objets</span>
        </span>
      </div>
    </div>
  );
};

export default PieceCard;
